export default __webpack_public_path__ + "static/media/Slide12.69b3c17b.jpg";